var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-field input-rule"},[_c('v-select',{attrs:{"options":_vm.options,"clearable":true,"multiple":_vm.multiple,"searchable":_vm.searchable},on:{"input":(v) => _vm.$emit('input', v)},model:{value:(_vm.newValue),callback:function ($$v) {_vm.newValue=$$v},expression:"newValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }